import { Outlet } from "react-router-dom";
import TailwindHeader from "../../components/TailwindHeader";

const TailwindLayout = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Smart Tailwind Header - automatically configures based on route */}
      <TailwindHeader />

      {/* Main Content Area */}
      <main className="pt-[72px] min-h-screen">
        <Outlet />
      </main>
    </div>
  );
};

export default TailwindLayout;